module.exports = __webpack_public_path__ + "static/fonts/Campton-Bold.f820d2a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Campton-Bold.woff
// module id = zaAj
// module chunks = 1